import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CrudService } from 'src/app/demo/service/crud.service';
import { AlertsService } from 'src/app/demo/service/alerts.service';
import { Field } from 'src/app/demo/interfaces/form-print.interface';
import { CoreUtilsService } from '../../utils/core-utils.service';
import { lastValueFrom } from 'rxjs';
import { FormPrintTwoComponent } from '../form-print-two/form-print-two.component';

@Component({
  selector: 'app-dialog-form-dynamic-two',
  templateUrl: './dialog-form-dynamic-two.component.html',
  styleUrl: './dialog-form-dynamic-two.component.scss'
})
export class DialogFormDynamicTwoComponent implements OnInit, AfterViewInit {

  @ViewChild('formPrintTwo') formPrintTwo: FormPrintTwoComponent;

  questions: Field[] = [];
  showButtonsForm: boolean = false;
  showModalButtons: boolean = false;
  showModalBtnEdit: boolean = false;
  colorBtn: string = 'verde';

  /**
    * @author Ministerio de Cultura
    * @createdate 2025-04-02
    * @description Almacena el estado de validación de cada paso del formulario en el componente <app-form-print/>.
    * Cada índice del arreglo representa un paso del formulario:
    * - `false` indica que el formulario no está validado.
    * - `true` indica que el formulario ha pasado la validación.
    */
  validFormPrint: { [key: string]: boolean } = {};

  constructor(
    private crudService: CrudService,
    private alertService: AlertsService,
    public dynamicDialogRef: DynamicDialogRef,
    public dynamicDialogConfig: DynamicDialogConfig,
    private coreUtils: CoreUtilsService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.questions = this.dynamicDialogConfig.data.questions;
    
    const isTypeOfAction: boolean = this.dynamicDialogConfig.data.hasOwnProperty('typeOfAction');
    const isShowButtonsForm: boolean = this.dynamicDialogConfig.data.hasOwnProperty('showButtonsForm');
    const isShowModalBtnEdit: boolean = this.dynamicDialogConfig.data.hasOwnProperty('showModalBtnEdit');
    const isShowModalButtons: boolean = this.dynamicDialogConfig.data.hasOwnProperty('showModalButtons');
    const isColorBtn: boolean = this.dynamicDialogConfig.data.hasOwnProperty('colorBtn');

    const { parent, key } = this.coreUtils.getTargetFromPath(this, "['questions']");
    parent[key].forEach((field: Field, position: number) => {
      parent[key] = this.coreUtils.setFieldDisabled(parent[key], position, isTypeOfAction ? this.dynamicDialogConfig.data.typeOfAction === 'view' : false);
    })

    this.showButtonsForm = isShowButtonsForm ? this.dynamicDialogConfig.data.showButtonsForm : false;
    this.showModalBtnEdit = isShowModalBtnEdit ? this.dynamicDialogConfig.data.showModalBtnEdit : false;
    this.showModalButtons = isShowModalButtons ? this.dynamicDialogConfig.data.showModalButtons : false;
    this.colorBtn = isColorBtn ? this.dynamicDialogConfig.data.colorBtn : 'verde'
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const modalBody = document.querySelector('.p-dialog-content') as HTMLElement;
      if (modalBody) {
        modalBody.scrollTop = 0;
      }
    }, 100);
  }

  async onSubmit() {
    const confirmFrom = await this.alertService.showConfirmAlert({ html: '¿Desea enviar la información registrada?' });
    if (!confirmFrom.isConfirmed) return;

    const apiString = this.dynamicDialogConfig.data.apiString;
    const typeOfAction: 'add' | 'view' = this.dynamicDialogConfig.data.typeOfAction;
    const form = this.formPrintTwo.form;
    let res = null;

    if (apiString) {
      if (typeOfAction === 'add')
        res = await this.saveData(apiString.save, form.value);
      else if (typeOfAction === 'view')
        res = await this.updateData(apiString.update, form.value, form.value.id);

      this.alertService.showAlertNotification({ html: res.message });
      this.dynamicDialogRef.close(res);
    } else {
      this.dynamicDialogRef.close(form);
    }
  }

  async saveData(endpointName: string, form: any): Promise<any> {
    try {
      return await lastValueFrom(
        this.crudService.postData({ url: endpointName, formData: form })
      );
    } catch (err) {
      console.error('❌ Error al guardar los datos:', err);
      throw err;
    }
  }

  async updateData(endpointName: string, form: any, _id: number): Promise<any> {
    try {
      return await lastValueFrom(
        this.crudService.putData({ url: endpointName, id: _id, formData: form })
      );
    } catch (err) {
      console.error('❌ Error al actualizar los datos:', err);
      throw err;
    }
  }

  onClickEdit() {
    const { parent, key } = this.coreUtils.getTargetFromPath(this, "['questions']");
    parent[key].forEach((field: Field, position: number) => {
      parent[key] = this.coreUtils.setFieldDisabled(parent[key], position, false);
    })

    this.dynamicDialogConfig.header = 'Editar información';
    this.showModalButtons = true;
    this.showModalBtnEdit = false;
  }

  onCancel(): void {
    this.dynamicDialogRef.close();
  }

  /**
   * @author Ministerio de cultura
   * @createdate 2025-04-02
   * @description Verifica si el botón de submit o guardar debe estar deshabilitado.
   * El botón estará deshabilitado si todos los elementos del array `validFormPrint` son `true`
   *
   * @returns {boolean} `true` si el botón debe estar deshabilitado, `false` en caso contrario.
   */
  get btnIsDisabled(): boolean {
    return Object.values(this.validFormPrint).every(item => item === true);
  }

  onValidFormChange(key: string, value: boolean): void {
    this.validFormPrint[key] = value;
    this.cdr.detectChanges();
  }
}
